export enum DocumentsSuccessCodes {
  DOCUMENT_UPLOAD_SUCCESS = 'document_upload_success',
}
